import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import Row from 'reactstrap/lib/Row';
/* Constants */
import { TrackingConstant } from 'client/tracking/constant';

import './installed-upgrades.scss';

export function InstalledUpgrades({ options = [], toggleModal = noop }) {
  const [isItemOpened, setIsItemOpened] = useState(false);

  const handleToggle = useCallback(
    event => {
      setIsItemOpened(!isItemOpened);
      event.preventDefault();
    },
    [isItemOpened]
  );

  return (
    <Row
      className={classnames('installed-upgrades mx-0 px-0 pos-r')}
      data-tracking-parent="edm-entry-options-and-packages"
    >
      <details open={isItemOpened} className="w-100 mb-1_5">
        <summary
          className="d-flex justify-content-between py-1 c-pointer"
          data-tracking-id="vdp_view_content"
          data-subaction-name={TrackingConstant.VIEW_FEATURES}
          data-tracking-value="Installed Upgrades"
          onClick={handleToggle}
          data-no-refresh
        >
          <h3 className="feature-title fw-bold m-0 size-16">
            <i className="icon-star-full me-1" aria-hidden />
            Installed Upgrades
          </h3>
          <i
            className={classnames('medium text-primary-darker', {
              'icon-arrow-down4': !isItemOpened,
              'icon-arrow-up4': isItemOpened,
            })}
            aria-hidden
          />
        </summary>
        <ul className="m-0 list-unstyled">
          {options.map(({ name, id }) => {
            return (
              <li key={id} className="upgrade-item py-1 d-flex justify-content-between">
                <div className="fw-medium ps-0">{name}</div>
              </li>
            );
          })}
        </ul>
        <button
          className="gradient pos-a left-0 right-0"
          onClick={toggleModal}
          data-tracking-id="vdp_view_content"
          data-subaction-name={TrackingConstant.VIEW_FEATURES}
          tabIndex={-1}
          aria-hidden
        />
      </details>
    </Row>
  );
}

InstalledUpgrades.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})),
  toggleModal: PropTypes.func,
};
